// extracted by mini-css-extract-plugin
module.exports = {"useFade-fadeIn":"UsualProductsSlot_useFade-fadeIn__TuWy6","useFade-fadeOut":"UsualProductsSlot_useFade-fadeOut__ptpgD"};